import { Outlet } from 'react-router-dom'
import Tenthgrade_k10_subjects from './tenthgrade_k10_subjects.jsx';
import TopNavbar from '../../components/TopNavbar.jsx';


const Tenthgrade_k10 = ( ) => {
 
  return (
    <>
   
   
   <TopNavbar />
  <Tenthgrade_k10_subjects />  
  
     <Outlet />
    
     </>

  )
}

export default Tenthgrade_k10;